const StatusResponseApiUrls = {
  GET: `${process.env.REACT_APP_USER_DOC_GEN_URL}/doc-gen/statusmessage/response/cusres/get`,
  //POST: `${process.env.REACT_APP_USER_DOC_GEN_URL}/doc-gen/cusres`
  POST: `${process.env.REACT_APP_USER_DOC_GEN_URL}/doc-gen/statusmessage/upload`
};

export default StatusResponseApiUrls;
